import { PagingPanel as TempPagingPanel } from '@devexpress/dx-react-grid-material-ui';
import i18n from '@shared/config/i18n';

const { t } = i18n;

const getVisibility = ({ columns, hiddenColumnNames }) => {
  const withoutHidden = !columns && !hiddenColumnNames;
  let hasLeastOneVisibleColumn = false;

  if (!withoutHidden) {
    hasLeastOneVisibleColumn = columns.length !== hiddenColumnNames.length;
  }

  return withoutHidden || hasLeastOneVisibleColumn;
};

const defaultPageSizes = [10, 25, 50, 100];
const defaultMessages = { rowsPerPage: t('EntriesPerPage'), info: '' };

const PagingPanel = ({
  columns,
  hiddenColumnNames,
  pageSizes = defaultPageSizes,
  messages = defaultMessages,
  ...props
}) => {
  const visible = getVisibility({ columns, hiddenColumnNames });

  return visible ? (
    <TempPagingPanel pageSizes={pageSizes} messages={messages} {...props} />
  ) : null;
};

export { PagingPanel };
